import React from 'react';
import PrevArrowIcon from 'assets/chevron-left';
import NextArrowIcon from 'assets/chevron-right';

interface CalendarNavigationButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  direction: 'prev' | 'next';
}

const CalendarNavigationButton = ({
  direction,
  disabled,
  ...props
}: CalendarNavigationButtonProps) => {
  return (
    <button
      type="button"
      tabIndex={0}
      aria-label={direction === 'prev' ? 'Previous month' : 'Next month'}
      aria-disabled={disabled || undefined}
      disabled={disabled}
      {...props}
    >
      {direction === 'prev' && (
        <PrevArrowIcon color="var(--way-palette-black-80)" scale={1.5} />
      )}
      {direction === 'next' && (
        <NextArrowIcon color="var(--way-palette-black-80)" scale={1.5} />
      )}
    </button>
  );
};

export default CalendarNavigationButton;
